var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Directive, Input, ElementRef, HostListener, ComponentFactoryResolver, ApplicationRef, Injector } from '@angular/core';
import { TooltipComponent } from '../../components/core/tooltip';
/**
 * Usage example:
 * On hover, display a tool tip above the button
 * <button (click)="doSomething()" tooltip [tooltipDisabled]="true" text="My Text" position="top">Hello World</button>
 */
var TooltipDirective = /** @class */ (function () {
    function TooltipDirective(elem, applicationRef, injector, componentFactory) {
        this.elem = elem;
        this.applicationRef = applicationRef;
        this.injector = injector;
        this.componentFactory = componentFactory;
        this.setTextAsInnerHTML = false;
        this.position = 'right'; // accepted values: ['right', 'left', 'top', 'bottom']
        // if set to true, then tooltip will be hidden even when mouse is over the target element
        this.tooltipDisabled = false;
        this.extraOffset = 0;
        this.customClass = '';
        this.offsetX = 10;
        this.offsetY = 5;
    }
    TooltipDirective.prototype.mouseEnter = function (event) {
        this.mouseX = event.x;
        this.mouseY = event.y;
        if (!this.tooltipDisabled) {
            this.tooltip.instance.show = true;
        }
        this.calculateTooltipPosition();
    };
    TooltipDirective.prototype.mouseMove = function (event) {
        if (this.tooltip.instance.show && this.position === 'follow') {
            this.mouseX = event.x;
            this.mouseY = event.y;
            this.calculateTooltipPosition();
        }
    };
    TooltipDirective.prototype.mouseLeave = function () {
        this.tooltip.instance.show = false;
    };
    TooltipDirective.prototype.windowResized = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.tooltip && this.tooltip.instance)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.calculateTooltipPosition()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TooltipDirective.prototype.onWindowScroll = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var boundingRect, isMouseOver;
            return __generator(this, function (_a) {
                if (this.tooltip && this.tooltip.instance) {
                    boundingRect = this.elem.nativeElement.getBoundingClientRect();
                    isMouseOver = this.isMouseOver(boundingRect, event.x, event.y);
                    if (!isMouseOver && this.tooltip.instance.show) {
                        this.tooltip.instance.show = false;
                    }
                    else if (isMouseOver && !this.tooltip.instance.show) {
                        this.tooltip.instance.show = true;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * On init, resolve the component -- returns an object that
     * knows how to create the component
     * then, create the component from the component factory
     */
    TooltipDirective.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tooltipFactory, location, disabledElementObserver;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tooltipFactory = this.componentFactory.resolveComponentFactory(TooltipComponent);
                        this.tooltip = tooltipFactory.create(this.injector);
                        this.applicationRef.attachView(this.tooltip.hostView);
                        location = this.applicationRef.components[0].location.nativeElement;
                        location.appendChild(this.tooltip.location.nativeElement);
                        return [4 /*yield*/, this.calculateTooltipPosition()];
                    case 1:
                        _a.sent();
                        this.tooltip.instance.customClass = this.customClass;
                        // If the element we attached this directive to is disabled, we need to manually hide it,
                        // because the events that would normally do this don't trigger for disabled elements.
                        this.tooltip.instance.isDisabled = this.elem.nativeElement.disabled;
                        disabledElementObserver = new MutationObserver(function (mutations) {
                            var disabledToggled = mutations.find(function (mutation) { return mutation.attributeName === 'disabled'; });
                            if (disabledToggled) {
                                _this.tooltip.instance.isDisabled = disabledToggled.target.disabled;
                            }
                            // If the tooltip's element gets disabled, manually hide the tooltip as well.
                            // This prevents the tooltip from appearing if the element's reenabled, but the user isn't hovering over it..
                            if (_this.tooltip.instance.isDisabled) {
                                _this.tooltip.instance.show = false;
                            }
                        });
                        disabledElementObserver.observe(this.elem.nativeElement, { attributes: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    TooltipDirective.prototype.ngOnChanges = function (inputChanges) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.tooltip || (inputChanges.text && inputChanges.text.firstChange)) {
                            return [2 /*return*/];
                        }
                        if (inputChanges.tooltipDisabled && inputChanges.tooltipDisabled.currentValue) {
                            this.tooltip.instance.show = false;
                        }
                        return [4 /*yield*/, this.calculateTooltipPosition()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TooltipDirective.prototype.ngOnDestroy = function () {
        if (this.tooltip) {
            this.tooltip.destroy();
        }
    };
    TooltipDirective.prototype.calculateTooltipPosition = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tooltipOffset, rect, tooltipRect, windowWidth, windowHeight, positionX, positionY, tooltipRectUpdated;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tooltip.instance.text = this.text;
                        this.tooltip.instance.setTextAsInnerHTML = this.setTextAsInnerHTML;
                        this.tooltip.instance.position = this.position;
                        this.tooltip.instance.horizontalOffset = 0;
                        return [4 /*yield*/, this.catchRenderingThreadsUp()];
                    case 1:
                        _a.sent();
                        tooltipOffset = 4 + this.extraOffset;
                        rect = this.elem.nativeElement.getBoundingClientRect();
                        tooltipRect = this.tooltip.location.nativeElement.children[0].getBoundingClientRect();
                        windowWidth = window.innerWidth || document.documentElement.clientWidth;
                        windowHeight = window.innerHeight || document.documentElement.clientHeight;
                        positionX = 0;
                        positionY = 0;
                        switch (this.position) {
                            case 'right':
                                positionX = rect.x + rect.width + tooltipOffset;
                                positionY = rect.y + rect.height / 2 - tooltipRect.height / 2;
                                break;
                            case 'left':
                                positionX = rect.x - tooltipRect.width - tooltipOffset;
                                positionY = rect.y + rect.height / 2 - tooltipRect.height / 2;
                                break;
                            case 'bottom':
                                positionX = rect.x + rect.width / 2 - tooltipRect.width / 2;
                                positionY = rect.y + rect.height + tooltipOffset;
                                break;
                            case 'top':
                                positionX = rect.x + rect.width / 2 - tooltipRect.width / 2;
                                // Remove the 4px default offset to avoid altering tooltips without a defined offset.
                                positionY = rect.y - rect.height - tooltipRect.height - (tooltipOffset - 4);
                                break;
                            case 'follow':
                                positionX = this.mouseX + this.offsetX;
                                positionY = this.mouseY + this.offsetY;
                                break;
                            default:
                                break;
                        }
                        this.tooltip.instance.positionX = Math.floor(positionX);
                        this.tooltip.instance.positionY = Math.floor(positionY);
                        /**
                         * See BB-5597
                         * We recalculate the bounding client rect after the view is fully rendered so we can ensure the tooltip doesn't extend beyond the edge of the window
                         */
                        return [4 /*yield*/, this.catchRenderingThreadsUp()];
                    case 2:
                        /**
                         * See BB-5597
                         * We recalculate the bounding client rect after the view is fully rendered so we can ensure the tooltip doesn't extend beyond the edge of the window
                         */
                        _a.sent();
                        tooltipRectUpdated = this.tooltip.location.nativeElement.children[0].getBoundingClientRect();
                        if (!this.isTooltipInView(tooltipRectUpdated, windowWidth, windowHeight)) {
                            switch (true) {
                                case tooltipRectUpdated.right >= windowWidth:
                                    // tooltip is overflowing the right side of the viewport
                                    this.tooltip.instance.horizontalOffset = windowWidth - tooltipRectUpdated.right - 2;
                                    break;
                                case tooltipRectUpdated.left < 0:
                                    // tooltip is overflowing the left side of the viewport
                                    this.tooltip.instance.horizontalOffset = 0;
                                    break;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TooltipDirective.prototype.isTooltipInView = function (boundingRect, windowWidth, windowHeight) {
        return (boundingRect.top >= 0 &&
            boundingRect.left >= 0 &&
            boundingRect.right <= windowWidth &&
            boundingRect.bottom <= windowHeight);
    };
    TooltipDirective.prototype.isMouseOver = function (boundingRect, mouseX, mouseY) {
        return (mouseX > boundingRect.x &&
            mouseX < boundingRect.x + boundingRect.width &&
            mouseY > boundingRect.y &&
            mouseY < boundingRect.y + boundingRect.height);
    };
    TooltipDirective.prototype.catchRenderingThreadsUp = function () {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                return resolve(true);
            }, 10);
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TooltipDirective.prototype, "text", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "setTextAsInnerHTML", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "position", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "tooltipDisabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "extraOffset", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "customClass", void 0);
    __decorate([
        HostListener('mouseenter', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], TooltipDirective.prototype, "mouseEnter", null);
    __decorate([
        HostListener('mousemove', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], TooltipDirective.prototype, "mouseMove", null);
    __decorate([
        HostListener('mouseleave'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipDirective.prototype, "mouseLeave", null);
    __decorate([
        HostListener('window:resize'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TooltipDirective.prototype, "windowResized", null);
    __decorate([
        HostListener('mousewheel', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", Promise)
    ], TooltipDirective.prototype, "onWindowScroll", null);
    TooltipDirective = __decorate([
        Directive({
            selector: '[tooltip]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            ApplicationRef,
            Injector,
            ComponentFactoryResolver])
    ], TooltipDirective);
    return TooltipDirective;
}());
export { TooltipDirective };
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./src/directives/tooltip/index.ts.pre-build-optimizer.js